import{jsx as e}from"react/jsx-runtime";import{styled as t}from"styled-components";const a=t.li`
  text-shadow: 1px 1px 2px #999999;
  white-space: nowrap;

  width: 96px;
  height: 29px;
  padding-left: 4px;
  margin-top: 2px;

  float: left;
  background: url('images/tab_header_inactive.png') no-repeat bottom right transparent;

  &.selected {
    background: url('images/tab_header_active.png') no-repeat bottom right transparent;
    line-height: 1.2;

    a {
      cursor: text;
    }
  }
  a {
    float: left;
    padding: 0.5em 1em;
    padding-left: 24px;
    cursor: pointer;
  }
  a#guide-tab {
    background: url('images/info_16x16.png') no-repeat scroll left center transparent;
  }
  a#my-menu-tab {
    background: url('images/star_16x16.png') no-repeat scroll left center transparent;
    padding-left: 15px;
  }
  a.usual#job-tab {
    background: url('images/gear_wheel_16x16.png') no-repeat scroll left center transparent;
  }
  a.running#job-tab {
    background: url('images/loading.png') no-repeat scroll left center transparent;
  }
`;function r({title:t,tab:r,currentTab:n,setCurrentTab:o,aId:l,aClassName:p}){return e(a,{className:r===n?"selected":"",onClick:()=>o(r),children:e("a",{id:l,className:p,children:t})})}export{r as TabItem};
